import styled from "@emotion/styled";

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
  background-color: ${({ theme }) => theme.colors.grey.x25};
  flex-shrink: 0;
  width: 100%;
`;

export const StyledSectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSectionHeaderText = styled.h3(({ theme }) => ({
  fontSize: theme.fontSizes.medium,
  fontWeight: theme.fontWeights.medium,
  color: theme.colors.grey.x600,
  margin: 0,
}));
